/**
 * Interleaves two arrays, alternating elements from each array.
 * Starts with the first array, then the second, and so on.
 *
 * @param firstArray - The first array to interleave
 * @param secondArray - The second array to interleave
 * @returns A new array with interleaved elements
 *
 * @example
 * interleaveArrays([1, 3, 5], [2, 4, 6]) // [1, 2, 3, 4, 5, 6]
 * interleaveArrays([1, 3], [2, 4, 6, 8]) // [1, 2, 3, 4, 6, 8]
 */
export function interleaveArrays<T>(firstArray: T[], secondArray: T[]): T[] {
  const result: T[] = [];
  const maxLength = Math.max(firstArray.length, secondArray.length);

  for (let i = 0; i < maxLength; i++) {
    if (i < firstArray.length) {
      result.push(firstArray[i]);
    }
    if (i < secondArray.length) {
      result.push(secondArray[i]);
    }
  }

  return result;
}
